import Statusbar from '../../Statusbar';
import decodeHTMLEntities from '../../utils/decodeHTMLEntities';
import Contest from '../../Contest';
import Animation from '../../Animation';
import simpleBarrier from 'simple-barrier';
import showNotificationCentered from '../../utils/showNotificationCentered';
import confetti from 'canvas-confetti';
import { Fireworks } from 'fireworks-js';
import * as PIXI from 'pixi.js-legacy';

export default function userExecutor({
	name = '',
	avatar = '',
	text = '',
	variation = 'default',
	animation = '',
	duration = 10,
	mode = 'member',
	avatarSettings = {},
}, done) {
	// eslint-disable-next-line max-len
	log(`Notifications.doUser "${name}" ("${text}") with avatar ${avatar} and variation ${variation} in mode ${mode} and animation ${animation} for ${duration}s`);

	Statusbar.addStatus({ title: text, subtitle: name, avatar });

	switch (animation) {
	case 'sun_rays':
		return doUserRays({ text, avatar, name, duration }, done);
	case 'splash_in':
		return doUserSplash({ text, avatar, name, duration, mode }, done);
	case 'confetti':
		return doUserConfetti({ text, avatar, name, duration }, done);
	case 'fireworks':
		return doUserFireworks({ text, avatar, name, duration }, done);
	case 'space':
		return doUserSpace({ text, avatar, name, duration }, done);
	case 'rocket_flying':
		return doUserRocketFlying({ text, name, duration, avatarSettings }, done);
	case 'warning':
		return doUserWarning({ text, name, duration }, done);
	case 'warning_personal':
		return doUserWarningPersonal({ text, avatar, name, duration }, done);
	default:
		return doUserDefault({ text, avatar, name, animation, duration }, done);
	}

}

function doUserRays({ text, avatar, name, duration }, done) {
	const textLines = text.split(/\n/);
	let template = '<div class="notification-user-default">';
	if (avatar) {
		template +=
				`<div class="user-avatar-wrap">
					<div class="user-avatar-rays"></div>
					<div class="user-avatar"><img class="user-avatar-img" src="${avatar}" alt="" /></div>
				</div>`;
	}

	template += `<h1>${name}</h1>`;
	$.each(textLines, function(index, line) {
		template += `<p>${line}</p>`;
	});
	template += '</div>';

	const el = $(template);

	return showNotificationCentered(el, duration, done);
}

function doUserDefault({ text, avatar, name, animation, duration }, done) {
	let template = '<div class="notification-user-default">';
	if (avatar) {
		template +=
			`<div class="user-avatar-wrap">
			<div class="user-avatar"><img class="user-avatar-img" src="${avatar}" alt="" /></div>
			</div>`;
	}
	template +=
		`<h1>${name}</h1>
		<p>${text}</p>
		</div>`;
	const el = $(template);

	// Background Animation
	if (animation) {
		const barrier = simpleBarrier();
		const animationForceEnd = showNotificationCentered(el, duration, barrier.waitOn());
		const backgroundForceEnd = Animation.init(animation, duration, barrier.waitOn());

		barrier.endWith(() => {
			done?.();
		});

		return () => {
			animationForceEnd();
			backgroundForceEnd();
		};
	} else {
		return showNotificationCentered(el, duration, done);
	}
}

function doUserConfetti({ text, avatar, name, duration }, done) {
	const textLines = text.split(/\n/);
	let template = '<div class="notification-user-default">';
	if (avatar) {
		template +=
			`<div class="user-avatar-wrap">
			<div class="user-avatar"><img class="user-avatar-img" src="${avatar}" alt="" /></div>
			</div>`;
	}
	template += `<h1>${name}</h1>`;
	$.each(textLines, function(index, line) {
		template += `<p>${line}</p>`;
	});
	template += '</div>';

	const el = $(template);

	const barrier = simpleBarrier();
	const notificationForceEnd = showNotificationCentered(el, duration, barrier.waitOn());

	// Inject a canvas into the .notification element after it has been appended to the DOM.
	// z-index 1 puts it above the dark overlay (z-index 0) but below the content (z-index 8).
	const notificationEl = el.closest('.notification').get(0);
	const confettiGradient = 'radial-gradient(' +
		'ellipse 70% 60% at 50% 35%,' +
		'rgba(10, 31, 61, 0.55) 0%,' +
		'rgba(1, 13, 23, 0.93) 55%,' +
		'rgba(1, 13, 23, 1) 100%)';
	$(notificationEl).find('.overlay').css('background', confettiGradient);
	const canvas = document.createElement('canvas');
	canvas.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;pointer-events:none;';
	notificationEl.appendChild(canvas);

	const myConfetti = confetti.create(canvas, { resize: true });

	const base = {
		startVelocity: 30,
		spread: 120,
		ticks: 600,
		gravity: 0.6,
	};

	function fireConfetti() {
		myConfetti($.extend({}, base, { particleCount: 50, origin: { x: 0.1, y: 0 }}));
		myConfetti($.extend({}, base, { particleCount: 50, origin: { x: 0.3, y: 0 }}));
		myConfetti($.extend({}, base, { particleCount: 50, origin: { x: 0.5, y: 0 }}));
		myConfetti($.extend({}, base, { particleCount: 50, origin: { x: 0.7, y: 0 }}));
		myConfetti($.extend({}, base, { particleCount: 50, origin: { x: 0.9, y: 0 }}));
	}

	fireConfetti();
	// eslint-disable-next-line no-magic-numbers
	const confettiInterval = setInterval(fireConfetti, 800);

	barrier.endWith(function() {
		clearInterval(confettiInterval);
		myConfetti.reset();
		done?.();
	});

	return function() {
		clearInterval(confettiInterval);
		myConfetti.reset();
		notificationForceEnd();
	};
}

function doUserFireworks({ text, avatar, name, duration }, done) {
	const textLines = text.split(/\n/);
	let template = '<div class="notification-user-default">';
	if (avatar) {
		template +=
			`<div class="user-avatar-wrap">
			<div class="user-avatar"><img class="user-avatar-img" src="${avatar}" alt="" /></div>
			</div>`;
	}
	template += `<h1>${name}</h1>`;
	$.each(textLines, function(index, line) {
		template += `<p>${line}</p>`;
	});
	template += '</div>';

	const el = $(template);

	const barrier = simpleBarrier();
	const notificationForceEnd = showNotificationCentered(el, duration, barrier.waitOn());

	const notificationEl = el.closest('.notification').get(0);
	const fireworksBg = 'radial-gradient(' +
		'ellipse at 50% 60%,' +
		'#4B1A8C 0%,' +
		'#2D0B5C 60%,' +
		'#1A0038 100%)';
	$(notificationEl).find('.overlay').css('background', fireworksBg);

	const container = document.createElement('div');
	container.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;pointer-events:none;';
	notificationEl.appendChild(container);

	const fw = new Fireworks(container, {
		autoresize: true,
		opacity: 0.6,
		acceleration: 1.05,
		friction: 0.97,
		gravity: 1.5,
		particles: 60,
		traceLength: 4,
		traceSpeed: 8,
		explosion: 6,
		intensity: 25,
		flickering: 60,
		lineStyle: 'round',
		hue: { min: 260, max: 320 },
		delay: { min: 20, max: 40 },
		rocketsPoint: { min: 20, max: 80 },
		lineWidth: {
			explosion: { min: 1, max: 3 },
			trace: { min: 1, max: 2 },
		},
		brightness: { min: 60, max: 90 },
		decay: { min: 0.01, max: 0.02 },
	});

	fw.start();

	barrier.endWith(function() {
		fw.stop();
		done?.();
	});

	return function() {
		fw.stop();
		notificationForceEnd();
	};
}

function doUserSplash({ text, avatar, name, duration, mode }, done) {
	const decodedText = decodeHTMLEntities(text);

	const data = {
		items: [{
			name: name,
			avatar: avatar,
		}],
		target: {
			formatted_value: decodedText,
		},
		duration,
		mode,
	};

	Screen.changeMode('contest');
	Contest.start(data, done);

	return () => {
		Screen.changeMode('slides');
	};
}

function doUserSpace({ text, avatar, name, duration }, done) {
	const textLines = text.split(/\n/);
	let template = '<div class="notification-user-default">';
	if (avatar) {
		template += '<div class="space-avatar-wrap">';
		template += `<div class="space-avatar"><img class="user-avatar-img" src="${avatar}" alt="" /></div>`;
		template += '</div>';
	}
	template += `<h1>${name}</h1>`;
	$.each(textLines, (i, line) => { template += `<p>${line}</p>`; });
	template += '</div>';

	const el = $(template);
	const barrier = simpleBarrier();
	const notificationForceEnd = showNotificationCentered(el, duration, barrier.waitOn());
	const notificationEl = el.closest('.notification').get(0);

	applySpaceBackground(notificationEl);

	barrier.endWith(() => { done?.(); });
	return () => { notificationForceEnd(); };
}

// eslint-disable-next-line max-len
const ROCKET_SPINE_URL = 'https://files.static.plecto.com/animations/rocket_2705/Vehicle.json';
// eslint-disable-next-line max-len
const HUMAN_SPINE_URL = 'https://files.static.plecto.com/animations/avatar_1012-new/Plecto_character.json';
// eslint-disable-next-line max-len
const ASTRONAUT_SPINE_URL = 'https://files.static.plecto.com/animations/astronaut_2705-new/Plecto_astronaut.json';
const SPACE_BG_URL = 'https://files.static.plecto.com/contest/backgrounds/space-f6d64e9f93.png';

// Replicate @plecto/avatar skin mapping for human characters (Spine 3.8 composite skins)
function applyHumanSkins(pilot, humanSettings) {
	const { skin, hair, face, tshirt, shorts } = humanSettings || {};
	const skinNames = [];

	if (skin) { skinNames.push('Leather/leather_' + skin); }
	if (tshirt) { skinNames.push('T-shirt/t_shirt_' + tshirt); }
	if (shorts) { skinNames.push('Shorts/shorts_' + shorts); }

	const hairColor = (hair && hair.color) || 'dark';
	if (hair && hair.type === 'short') {
		skinNames.push('Hair_short/hair_short_' + hairColor);
	} else if (hair && hair.type === 'medium') {
		skinNames.push('Hair_medium/hair_medium_' + hairColor);
	} else if (hair && hair.type === 'long') {
		skinNames.push('Hair_long/hair_long_' + hairColor);
	} else {
		skinNames.push('stubble_hair/stubble_hair2');
	}

	const featColor = (face && face.featureColor) || 'dark';
	if (face && face.feature === 'freckles') {
		skinNames.push('freckles');
	} else if (face && face.feature === 'beard') {
		skinNames.push('Beard/beard_' + featColor);
	} else if (face && face.feature === 'moustache') {
		skinNames.push('Mustache/mustache_' + featColor);
	} else {
		skinNames.push('default');
	}

	try {
		const SkinClass = PIXI.spine.core.Skin;
		const combined = new SkinClass('combined');
		skinNames.forEach(skinName => {
			const found = pilot.skeleton.data.findSkin(skinName);
			if (found) { combined.addSkin(found); }
		});
		pilot.skeleton.setSkin(combined);
	} catch (e) { /* fall through to setSlotsToSetupPose */ }
	pilot.skeleton.setSlotsToSetupPose();
}

function applySpaceBackground(notificationEl) {
	const overlay = $(notificationEl).find('.overlay');
	overlay.css('background', 'rgba(26, 0, 56, 0.25)');
	const spaceBgEl = $('<div>').css({
		position: 'absolute',
		top: 0, left: 0, width: '100%', height: '100%',
		'background-image': `url('${SPACE_BG_URL}')`,
		'background-size': 'cover',
		'background-position': 'center',
		opacity: 0.45,
		'z-index': 0,
	});
	overlay.append(spaceBgEl);
}

function doUserRocketFlying({ text, name, duration, avatarSettings }, done) {
	const textLines = text.split(/\n/);

	// Static text — name at top, message at bottom, rocket flies through the middle gap
	let textTemplate = '<div class="notification-rocket-stage">';
	textTemplate += `<h1 class="notification-rocket-name">${name}</h1>`;
	textTemplate += '<div class="notification-rocket-message">';
	$.each(textLines, (i, line) => { textTemplate += `<p>${line}</p>`; });
	textTemplate += '</div>';
	textTemplate += '</div>';

	const lifecycleEl = $('<div>').css({ width: 1, height: 1, opacity: 0, 'pointer-events': 'none' });
	const barrier = simpleBarrier();
	const notificationForceEnd = showNotificationCentered(lifecycleEl, duration, barrier.waitOn());
	const notificationEl = lifecycleEl.closest('.notification').get(0);

	$(notificationEl).css('overflow', 'hidden');
	$(notificationEl).append($(textTemplate));
	applySpaceBackground(notificationEl);

	// Pixi canvas — full screen, transparent, z-index above overlay
	const W = window.innerWidth;
	const H = window.innerHeight;
	const pixiApp = new PIXI.Application({ width: W, height: H, transparent: true, antialias: true });
	const canvas = pixiApp.view;
	canvas.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:9;pointer-events:none;';
	notificationEl.appendChild(canvas);

	// eslint-disable-next-line no-magic-numbers
	const PILOT_SLOT = 1; // vehicle_back slot — pilot sits behind rocket body, shows through cockpit window
	// eslint-disable-next-line no-magic-numbers
	const PILOT_X = 350, PILOT_Y = -75, PILOT_SCALE = 1.7;
	// eslint-disable-next-line no-magic-numbers
	const ROCKET_HEIGHT_DIVISOR = 3000;
	// eslint-disable-next-line no-magic-numbers
	const FLY_IN_END = 0.12, HOVER_END = 0.82, OFFSCREEN_FACTOR = 0.8;
	// eslint-disable-next-line no-magic-numbers
	const BOB_PERIOD = 318, BOB_AMPLITUDE = 20, MS_PER_SECOND = 1000;
	// eslint-disable-next-line no-magic-numbers
	const EMPTY_ANIM_MIX = 1.0;

	// pixi-spine must be loaded BEFORE the loader so its middleware converts JSON → spineData.
	// Set window.PIXI first so pixi-spine can attach its loader plugin.
	window.PIXI = window.PIXI || PIXI;
	// eslint-disable-next-line global-require
	require('pixi-spine');

	// Determine character type and URL from avatar settings
	const kind = (avatarSettings && avatarSettings.kind) || 'astronaut';
	const characterUrl = kind === 'human' ? HUMAN_SPINE_URL : ASTRONAUT_SPINE_URL;

	// Rocket skin: avatarSettings.[kind].shipColor → 'rocket_<color>'
	const shipColor = avatarSettings && avatarSettings[kind] && avatarSettings[kind].shipColor;
	const rocketSkinName = shipColor ? 'rocket_' + shipColor : 'rocket_violet_1';

	const loader = new PIXI.Loader();
	loader.add('rocket', ROCKET_SPINE_URL);
	loader.add('character', characterUrl);

	const totalMs = duration * MS_PER_SECOND;
	const notificationStartTime = Date.now();

	loader.load((_, resources) => {
		if (destroyed) { return; }
		// Use remaining notification time so fly-out finishes exactly when notification ends
		const animStartTime = Date.now();
		const elapsed = animStartTime - notificationStartTime;
		// eslint-disable-next-line no-magic-numbers
		const animTotalMs = Math.max(totalMs - elapsed, 3000);
		if (!resources.rocket || !resources.rocket.spineData) { return; }

		// Animate message text in with the rocket fly-in — stays put when rocket leaves
		const flyInMs = Math.round(FLY_IN_END * animTotalMs);
		$(notificationEl).find('.notification-rocket-message').css({
			'animation-name': 'rocket-message-in',
			'animation-duration': flyInMs + 'ms',
			'animation-timing-function': 'ease-out',
			'animation-fill-mode': 'forwards',
		});
		const SpineClass = PIXI.spine && PIXI.spine.Spine;
		if (!SpineClass) { return; }

		// --- Rocket ---
		const rocket = new SpineClass(resources.rocket.spineData);
		try { rocket.skeleton.setSkinByName(rocketSkinName); } catch (e) { /* skin name may differ */ }
		rocket.skeleton.setSlotsToSetupPose();
		try { rocket.state.setAnimation(0, 'animation', true); } catch (e) { /* animation may differ */ }

		// --- Pilot character (Spine) inside rocket cockpit ---
		if (resources.character && resources.character.spineData) {
			const pilot = new SpineClass(resources.character.spineData);

			if (kind === 'human') {
				applyHumanSkins(pilot, avatarSettings && avatarSettings.human);
			} else {
				const suitColor = avatarSettings && avatarSettings.astronaut && avatarSettings.astronaut.suitColor;
				try { pilot.skeleton.setSkinByName(suitColor || 'violet_1'); } catch (e) { /* suit may differ */ }
				pilot.skeleton.setSlotsToSetupPose();
			}

			// Match dashboard positioning: createRocketSpine places pilot at (350, -75) scale (-1.7, -1.7)
			pilot.position.set(PILOT_X, PILOT_Y);
			pilot.scale.set(-PILOT_SCALE, -PILOT_SCALE);
			// eslint-disable-next-line no-magic-numbers
			try { pilot.state.setEmptyAnimation(0, EMPTY_ANIM_MIX); } catch (e) { /* may not exist */ }

			// Clip mask matching dashboard's createRocketSpine — applied to pilot, not slot container.
			// Large positive-coordinate rect hides the character below the cockpit window.
			const cockpitMask = new PIXI.Graphics();
			// eslint-disable-next-line no-magic-numbers
			cockpitMask.beginFill(0x000000).drawRect(0, 0, 6000, 5600).endFill();
			pilot.mask = cockpitMask;
			rocket.slotContainers[PILOT_SLOT].addChild(pilot);
			rocket.slotContainers[PILOT_SLOT].addChild(cockpitMask);
		}

		// --- Scale and animate rocket fly-through ---
		const rocketScale = H / ROCKET_HEIGHT_DIVISOR;
		rocket.scale.set(rocketScale);
		rocket.x = -W * OFFSCREEN_FACTOR;
		rocket.y = H / 2;
		pixiApp.stage.addChild(rocket);

		pixiApp.ticker.add(() => {
			const t = Math.min((Date.now() - animStartTime) / animTotalMs, 1);
			let x;
			if (t < FLY_IN_END) {
				const p = t / FLY_IN_END;
				x = -W * OFFSCREEN_FACTOR + (W / 2 + W * OFFSCREEN_FACTOR) * (1 - Math.pow(1 - p, 2));
			} else if (t < HOVER_END) {
				x = W / 2;
			} else {
				const p = (t - HOVER_END) / (1 - HOVER_END);
				x = W / 2 + W * OFFSCREEN_FACTOR * Math.pow(p, 2);
			}
			rocket.x = x;
			rocket.y = H / 2 + Math.sin(Date.now() / BOB_PERIOD) * BOB_AMPLITUDE;
		});
	});

	let destroyed = false;
	const destroyPixi = () => { if (!destroyed) { destroyed = true; pixiApp.destroy(true); } };
	barrier.endWith(() => { destroyPixi(); done?.(); });
	return () => { loader.reset(); destroyPixi(); notificationForceEnd(); };
}

function doUserWarning({ text, name, duration }, done) {
	const textLines = text.split(/\n/);
	const warningBg = 'radial-gradient(' +
		'ellipse 70% 55% at 50% 40%,' +
		'rgba(170, 15, 15, 0.45) 0%,' +
		'#010D17 60%)';

	// Single root element so showNotificationCentered centers rings + text together
	let template = '<div class="notification-user-default">';
	template += '<div class="warning-rings-wrapper">';
	template += '<div class="warning-ring"></div>';
	template += '<div class="warning-ring"></div>';
	template += '<div class="warning-ring"></div>';
	template += '<div class="warning-ring"></div>';
	template += '<div class="warning-icon-circle">!</div>';
	template += '</div>';
	template += `<h1>${name}</h1>`;
	$.each(textLines, function(index, line) {
		template += `<p>${line}</p>`;
	});
	template += '</div>';

	const el = $(template);

	const barrier = simpleBarrier();
	const notificationForceEnd = showNotificationCentered(el, duration, barrier.waitOn());

	const notificationEl = el.closest('.notification').get(0);
	$(notificationEl).find('.overlay').css('background', warningBg);

	barrier.endWith(function() {
		done?.();
	});

	return function() {
		notificationForceEnd();
	};
}

function doUserWarningPersonal({ text, avatar, name, duration }, done) {
	const textLines = text.split(/\n/);
	const warningBg = 'radial-gradient(' +
		'ellipse 70% 55% at 50% 40%,' +
		'rgba(170, 15, 15, 0.45) 0%,' +
		'#010D17 60%)';

	// Single root element so showNotificationCentered centers rings + text together
	let template = '<div class="notification-user-default">';
	template += '<div class="warning-rings-wrapper">';
	template += '<div class="warning-ring"></div>';
	template += '<div class="warning-ring"></div>';
	template += '<div class="warning-ring"></div>';
	template += '<div class="warning-ring"></div>';
	if (avatar) {
		template += '<div class="warning-avatar-circle">';
		template += `<img src="${avatar}" alt="" />`;
		template += '<div class="warning-badge">!</div>';
		template += '</div>';
	}
	template += '</div>';
	template += `<h1>${name}</h1>`;
	$.each(textLines, function(index, line) {
		template += `<p>${line}</p>`;
	});
	template += '</div>';

	const el = $(template);

	const barrier = simpleBarrier();
	const notificationForceEnd = showNotificationCentered(el, duration, barrier.waitOn());

	const notificationEl = el.closest('.notification').get(0);
	$(notificationEl).find('.overlay').css('background', warningBg);

	barrier.endWith(function() {
		done?.();
	});

	return function() {
		notificationForceEnd();
	};
}
